import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

export function useDeleteBadge() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, error } = useMutation({
    mutationFn: (badgeId: number) => {
      return api.admin.badges.deleteBadge({ params: { badge: badgeId } });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'badges'] });
      toaster.create({
        title: "Badge deleted successfully",
        type: "success",
      });
    },
    onError: (error) => {
      toaster.create({
        title: "Failed to delete badge",
        description: error.message || "An error occurred",
        type: "error",
      });
      console.error('[useDeleteBadge] Error:', error);
    },
  });

  return { mutate, mutateAsync, isPending, error };
}

export default useDeleteBadge;

